import { render, staticRenderFns } from "./GroupOfAccreditationCard.vue?vue&type=template&id=3632ad46&scoped=true"
import script from "./GroupOfAccreditationCard.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632ad46",
  null
  
)

export default component.exports